import React from "react";
import Link from "next/link";
import messages from "i18n/messages";
import { FormattedMessage } from "react-intl";

export default ({ date, org, spl }) => (
  <div className="spl-bestseat-tabs">
    <Link href={`/${org ? org.odn : ""}/b/${date.id}`}>
      <div
        onClick={() => (location.href = `/${org ? org.odn : ""}/b/${date.id}`)}
        className={`tab${!spl ? " active" : ""}`}
      >
        <div className="tab-icon">
          <span className="tt-icon tt-icon-left-arrow d-block d-sm-none"></span>
          <span className="tt-icon tt-icon-star d-none d-sm-block"></span>
        </div>
        <div className="tab-text">
          <div className="tab-title d-none d-sm-block">
            <FormattedMessage {...messages.bestseat} />
          </div>
          <div className="tab-title d-block d-sm-none">
            <FormattedMessage {...messages.goToBestSeatSelection} />
          </div>
          <FormattedMessage {...messages.ttWillPickBestPossibleSeatsForYou} />
        </div>
      </div>
    </Link>
    <Link href={`/${org ? org.odn : ""}/b/spl/${date.id}`}>
      <div
        onClick={() =>
          (location.href = `/${org ? org.odn : ""}/b/spl/${date.id}`)
        }
        className={`tab spl-tab${spl ? " active" : ""}`}
      >
        <div className="tab-icon">
          <span className="tt-icon tt-icon-stadium"></span>
        </div>
        <div className="tab-text">
          <div className="tab-title d-none d-sm-block">
            <FormattedMessage {...messages.seatingPlan} />
          </div>
          <div className="tab-title d-block d-sm-none">
            <FormattedMessage {...messages.goToSeatingPlan} />
          </div>
          <FormattedMessage {...messages.selectYourSeatsInSeatingPlan} />
        </div>
      </div>
    </Link>
  </div>
);
